var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row text-center",class:[
  {'justify-content-end': _vm.right},
  {'justify-content-start': _vm.left},
  {'justify-content-center':!_vm.right && !_vm.left}
]},[_c('beat-loader',{attrs:{"size":_vm.size,"loading":_vm.loading,"color":_vm.color}})],1),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }